module.exports = __webpack_public_path__ + "static/img/banner03.cfe7b38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner03.jpg
// module id = EcMp
// module chunks = 10